/* eslint-disable no-extend-native */
String.prototype.toCamelCase = function () {
  return this.toLowerCase()
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .trim()
    .split(" ")
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join("");
};

String.prototype.toPascalCase = function () {
  return this.toCamelCase().charAt(0).toUpperCase() + this.slice(1);
};
